module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SCROSS-3.e77ed078.jpg";